import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ConfigurationService } from '../configuration.service';
import { BranchMaster } from '../dashboard-config.model';
import { SearchDashboardConfigComponent } from './search-dashboard-config/search-dashboard-config.component';
import { SearchTimeConfigComponent } from './search-time-config/search-time-config.component';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-hospital-manager-configuration',
  templateUrl: './hospital-manager-configuration.component.html',
  styleUrls: ['./hospital-manager-configuration.component.scss']
})
export class HospitalManagerConfigurationComponent implements OnInit {
  dashboardConfigForm: FormGroup;
  timeConfigForm: FormGroup;
  workupConfigForm: FormGroup
  tabsName: any;
  workupList: any;
  public selectDashboardObj: any = {};
  selectedDashboardId: any;
  SavingPayLoad: any;
  timeConfigSavingPlayload: any;
  public selectTimeObj: any = {};
  selectedTimeId: any;
  branchIndex = [];
  activeBranch: BranchMaster[] = [];
  filteredBranchArray: Observable<any[]>;
  branchName: any;
  fK_BranchId: FormControl;
  workupIndex = [];
  TimeConfigList: any;
  timeIntervalAColor: any;

  constructor(public dialog: MatDialog, private _fb: FormBuilder, public configurationService: ConfigurationService,private authservice:AuthService) {
    this.getBranchList();
  }

  ngOnInit(): void {
    this.getNameList();
    this.getWorkupList();
    this.loadDashboardForm();
    this.loadTimeConfigForm();
    this.branchControll();
    this.getTimeConfigList();
  }

  loadDashboardForm() {
    this.dashboardConfigForm = this._fb.group({
      pK_TranID: ' ',
      sequence: ['', [Validators.required]],
      fK_RegID: ['', [Validators.required]],
      firstName:['', [Validators.required]],
      ageDesc: ['', [Validators.required]],
      categoryName: ['', [Validators.required]],
      party: ['', [Validators.required]],
      userhe: '',
      userar: ['', [Validators.required]],
      useropt: ['', [Validators.required]],
      userdct: ['', [Validators.required]],
      userphy:['', [Validators.required]],
      userproc: ['', [Validators.required]],
      usercons: ['', [Validators.required]],
      doctor: ['', [Validators.required]],
      optName: ['', [Validators.required]],
      proN:['', [Validators.required]],
      oldmrdno: ['', [Validators.required]],
      contactNo: ['', [Validators.required]],
      waitingReason: ['', [Validators.required]],
      companyName: '',
      sap: '',
      remarks: ['', [Validators.required]],
      adharCard: ['', [Validators.required]],
      ispd: ['', [Validators.required]],
      totalTime: '',
      pHy: ['', [Validators.required]],
      fK_BranchId: ['', [Validators.required]],
      isActive: '',
      returnWidth: ['', [Validators.required]],
      branchName: '',
      pkBranchId: '',
    });
  }
  reset() {
    this.loadDashboardForm();
    this.branchName = '';
  }

  getNameList() {
    this.configurationService.getHospitalManagerConfig().subscribe(data => {
      this.tabsName = data;
    });
  }

  getTimeConfigList() {
    this.configurationService.getTimeConfig().subscribe(data => {
      this.TimeConfigList = data;
    });
  }

  /* Get Country APi */
  getBranchList() {
    this.configurationService.getBranchMaster().subscribe(data => {
      let branchListActive = data;
      for (var i = 0; i < branchListActive.length; i++) {
        if (branchListActive[i].isActive == true) {
          this.branchIndex.push(branchListActive[i]);
          this.activeBranch = this.branchIndex;
        }
      }
      this.branchControll();
    });
  }
  branchControll() {
    this.fK_BranchId = new FormControl();
    this.filteredBranchArray = this.fK_BranchId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchfunction(country) : this.activeBranch.slice())
      );
  }

  changeBranch(event) {
    this.dashboardConfigForm.controls.fK_BranchId = event;
  }

  filterBranchfunction(name: string) {
    return this.activeBranch.filter(country =>
      country.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  selectTab(event) {
    let tabIndex = event.index;
    switch (tabIndex) {
      case 0: {
        tabIndex = 0;
        break;
      }
      case 1: {
        tabIndex = 1;
        this.getNameList();
        break;
      }
      case 2: {
        tabIndex = 2;
        break;
      }
    }
  }


  /** Seach Dashboard Config */
  searchDashboardConfig() {
    const dialogRef = this.dialog.open(SearchDashboardConfigComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "450px",
      width: "50%",
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectDashboardObj = this.configurationService.selectedDashboardData
      if (this.selectDashboardObj != null) {
        this.selectedDashboardId = this.selectDashboardObj.pK_TranID;
        this.setupdatedashboardForm(this.selectedDashboardId);
      }
    });
  }

  setupdatedashboardForm(Id) {
    this.configurationService.getDashboardConfigItem(Id).subscribe(data => {
      let selectedDashboardItem = data[0];
      this.dashboardConfigForm.patchValue({
        pK_TranID: selectedDashboardItem.pK_TranID,
        sequence: selectedDashboardItem.sequence,
        fK_RegID: selectedDashboardItem.fK_RegID,
        firstName: selectedDashboardItem.firstName,
        ageDesc: selectedDashboardItem.ageDesc,
        categoryName: selectedDashboardItem.categoryName,
        party: selectedDashboardItem.party,
        userhe: selectedDashboardItem.userhe,
        userar: selectedDashboardItem.userar,
        useropt: selectedDashboardItem.useropt,
        userdct: selectedDashboardItem.userdct,
        userphy: selectedDashboardItem.userphy,
        userproc: selectedDashboardItem.userproc,
        usercons: selectedDashboardItem.usercons,
        doctor: selectedDashboardItem.doctor,
        optName: selectedDashboardItem.optName,
        proN: selectedDashboardItem.proN,
        oldmrdno: selectedDashboardItem.oldmrdno,
        contactNo: selectedDashboardItem.contactNo,
        waitingReason: selectedDashboardItem.waitingReason,
        companyName: selectedDashboardItem.companyName,
        sap: selectedDashboardItem.sap,
        remarks: selectedDashboardItem.remarks,
        adharCard: selectedDashboardItem.adharCard,
        ispd: selectedDashboardItem.ispd,
        totalTime: selectedDashboardItem.totalTime,
        pHy: selectedDashboardItem.pHy,
        isActive: selectedDashboardItem.isActive,
        returnWidth: selectedDashboardItem.returnWidth,
        fK_BranchId: selectedDashboardItem.branchName
      });
    });
  }

  setDefaultDashboardConfig() {
    let defaultId = '-1';
    this.setupdatedashboardForm(defaultId);
  }

  /** Save and Update Dashboard Form */
  saveDashboardForm() {
    let dashboardform = this.dashboardConfigForm.controls;
    let branchID
    let getBranchName = this.activeBranch.filter(item => item.branchName == dashboardform.fK_BranchId.value);
    if(getBranchName.length == 0){
      this.configurationService.openSnackBar("Please select a valid Branch", "OK");
      return
    }else{
      branchID = getBranchName[0].pkBranchId;
    }
    this.SavingPayLoad = {
      pK_TranID: dashboardform.pK_TranID.value,
      sequence: dashboardform.sequence.value,
      fK_RegID: dashboardform.fK_RegID.value,
      firstName: dashboardform.firstName.value,
      ageDesc: dashboardform.ageDesc.value,
      categoryName: dashboardform.categoryName.value,
      party: dashboardform.party.value,
      userhe: dashboardform.userhe.value,
      userar: dashboardform.userar.value,
      useropt: dashboardform.useropt.value,
      userdct: dashboardform.userdct.value,
      userphy: dashboardform.userphy.value,
      userproc: dashboardform.userproc.value,
      usercons: dashboardform.usercons.value,
      doctor: dashboardform.doctor.value,
      optName: dashboardform.optName.value,
      proN: dashboardform.proN.value,
      oldmrdno: dashboardform.oldmrdno.value,
      contactNo: dashboardform.contactNo.value,
      waitingReason: dashboardform.waitingReason.value,
      companyName: dashboardform.companyName.value,
      sap: dashboardform.sap.value,
      remarks: dashboardform.remarks.value,
      adharCard: dashboardform.adharCard.value,
      ispd: dashboardform.ispd.value,
      totalTime: dashboardform.totalTime.value,
      pHy: dashboardform.pHy.value,
      fK_BranchId: branchID,
      isActive: dashboardform.isActive.value,
      returnWidth: dashboardform.returnWidth.value,
      branchName: dashboardform.branchName.value
    }

    if (dashboardform.pK_TranID.value === ' ' || dashboardform.pK_TranID.value == 0) {
      delete this.SavingPayLoad.pK_TranID;
      this.configurationService.addDashboardConfig(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.configurationService.openSnackBar("Dashboard Configuration Created Successfully " + data.id, "OK");
        }
      },
      err => {
        if (err.status == 403) {
          this.configurationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.configurationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.configurationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    } else {
      this.configurationService.addDashboardConfig(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.configurationService.openSnackBar("Dashboard Configuration Updated Successfully", "OK");
        }
      },
      err => {
        if (err.status == 403) {
          this.configurationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.configurationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.configurationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }
  }

  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  loadTimeConfigForm() {
    this.timeConfigForm = this._fb.group({
      pK_TranId: ' ',
      timeIntervalA: '',
      timeIntervalAColor: '#000000',
      timeIntervalB: '',
      timeIntervalBColor: '#000000',
      timeIntervalC: '',
      timeIntervalCColor: '#000000',
      isActive: false
    });
  }

  timeReset() {
    this.loadTimeConfigForm();
    this.getTimeConfigList();
  }

  saveTimeConfig() {
    if (this.TimeConfigList.length > 1) {
      this.configurationService.openSnackBar("You Can Modify Only", "OK");
    } else {
      this.saveTimeConfigForm();
    }
  }

  saveTimeConfigForm() {
    const timeForm = this.timeConfigForm.controls;
    let timeIntervalAColor = timeForm.timeIntervalAColor.value.slice(1);
    let timeIntervalBColor = timeForm.timeIntervalBColor.value.slice(1);
    let timeIntervalCColor = timeForm.timeIntervalCColor.value.slice(1);
    this.timeConfigSavingPlayload = {
      pK_TranId: timeForm.pK_TranId.value,
      timeIntervalA: timeForm.timeIntervalA.value,
      timeIntervalAColor: timeIntervalAColor,
      timeIntervalB: timeForm.timeIntervalB.value,
      timeIntervalBColor: timeIntervalBColor,
      timeIntervalC: timeForm.timeIntervalC.value,
      timeIntervalCColor: timeIntervalCColor,
      isActive: timeForm.isActive.value
    }

    if (timeForm.pK_TranId.value === ' ') {
      delete this.timeConfigSavingPlayload.pK_TranId;
      this.configurationService.addTimeConfig(this.timeConfigSavingPlayload).subscribe(data => {
        if (data.statusCode == 1) {
          this.configurationService.openSnackBar("Time Configuration Created Successfully " + data.id, "OK");
        }
      },
      err => {
        if (err.status == 403) {
          this.configurationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.configurationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.configurationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    } else {
      this.configurationService.addTimeConfig(this.timeConfigSavingPlayload).subscribe(data => {
        if (data.statusCode == 1) {
          this.configurationService.openSnackBar("Time Configuration Updated Successfully", "OK");
        }
      },
      err => {
        if (err.status == 403) {
          this.configurationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.configurationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.configurationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    }
  }

  /** Seach Time Config */
  searchTimeConfig() {
    const dialogRef1 = this.dialog.open(SearchTimeConfigComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "60%",
      width: "50%",
    });

    dialogRef1.afterClosed().subscribe(result => {
      this.selectTimeObj = this.configurationService.selectedTimeConfigData;
      if (this.selectTimeObj != null) {
        let timeIntervalAColor = this.selectTimeObj.timeIntervalAColor.padStart(6, '0')
        let timeIntervalBColor = this.selectTimeObj.timeIntervalBColor.padStart(6, '0')
        let timeIntervalCColor = this.selectTimeObj.timeIntervalCColor.padStart(6, '0')
        this.TimeConfigList.length = 0;
        this.timeConfigForm.patchValue({
          pK_TranId: this.selectTimeObj.pK_TranId,
          timeIntervalA: this.selectTimeObj.timeIntervalA,
          timeIntervalAColor: '#' + timeIntervalAColor,
          timeIntervalB: this.selectTimeObj.timeIntervalB,
          timeIntervalBColor: '#' + timeIntervalBColor,
          timeIntervalC: this.selectTimeObj.timeIntervalC,
          timeIntervalCColor: '#' + timeIntervalCColor,
          isActive: this.selectTimeObj.isActive
        });
      }
    });
  }

  /** Workup Configuration */
  getWorkupList() {
    this.configurationService.getWorkupConfig().subscribe(data => {
      this.workupList = data;
    });
  }

  selectWorkup(event, locationName) {
    this.workupList.forEach((item) => {
      if (item.locationName == locationName)
        item.isActive = event.checked;
        item.fk_CreatedById = this.authservice.Loggeduser.usertypeid;
    });
  }

  updateWorkupConfig() {
    const payLoad = {
      Arr: this.workupList
    }
    this.configurationService.updateWorkupConfig(payLoad).subscribe(data => {
      if (data.statusCode == 1) {
        this.configurationService.openSnackBar("Workup Configuration Updated Successfully", "OK");
      }
    },
    err => {
      if (err.status == 403) {
        this.configurationService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.configurationService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.configurationService.openSnackBar("API Failed", "OK");
      }
    }
  );
  }
  /** End Workup Configuration */
}